import { FC } from 'react'
import styled from 'styled-components'
import { TextLegacy } from '@/components/common'
import { ReviewStarRating } from '@/components/common/etc'
import { NewRow } from '@/components/common/layouts/NewRow'
import { LikeProductReview, ReviewImages } from '@/components/domains/etc'
import ReportProductReview from '@/components/domains/etc/ReportProductReview'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { IModelReview } from '@/containers/models/modelReview'
import { BOARD_DATE_DISPLAY_FORMAT, formatDate } from '@/utils/utilDate'

type ListItemProductReviewsProps = {
  review: IModelReview
}

const ListItemProductReview: FC<ListItemProductReviewsProps> = ({ review }) => {
  const {
    id: reviewId,
    username,
    productOptionName,
    reviewBody,
    score,
    reviewReviewImages,
    isPhotoReview,
    isLiked,
    createdAt,
    getLikedCount,
  } = review

  return (
    <StyledContainer>
      <NewRow justify="space-between" align="center">
        <NewRow align="center" gap={'0.5rem'}>
          <ReviewStarRating rating={score} />
          <TextLegacy size={{ xs: 12, md: 14 }}>{username}</TextLegacy>
        </NewRow>
        <TextLegacy size={{ xs: 12, md: 14 }} color="gray400">
          {formatDate(createdAt, BOARD_DATE_DISPLAY_FORMAT)}
        </TextLegacy>
      </NewRow>
      <NewRow>
        <TextLegacy size={{ xs: 12, md: 14 }} color="gray400">
          {`상품 : ${productOptionName}`}
        </TextLegacy>
      </NewRow>

      {isPhotoReview && (
        <StyledRow>
          {/* @ts-ignore TODO typescript 오류 수정 필요 */}
          <ReviewImages images={reviewReviewImages} />
        </StyledRow>
      )}

      <StyledRow>
        <TextLegacy size={{ xs: 13, md: 15 }} color="black">
          {reviewBody}
        </TextLegacy>
      </StyledRow>

      <NewRow align={'center'} justify={'space-between'} style={{ marginTop: 12 }}>
        <ReportProductReview reviewId={reviewId} />
        <LikeProductReview reviewId={reviewId} isLikedDefault={isLiked} likedCountDefault={getLikedCount()} />
      </NewRow>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  padding: 20px;
  border-bottom: 0.1rem solid ${GlobalColorEnum.Gray70};
`

const StyledRow = styled(NewRow)`
  margin-top: 15px;
`

export default ListItemProductReview
